import React from 'react'

const NewBtn = ({ style, className, children, onClick, disable }) => {
  return (
    <button style={style} className={className} disabled={disable} onClick={onClick}>{children}</button>
  )
}

export default NewBtn